import Visible from '@portalterreno/react-ui/Visible';
import { Col, Row } from '@portalterreno/react-ui-core/Grid';
import React, { memo, useState } from 'react';

import MenuDesktop from './HeaderDesktop/MenuDesktop';
import AccountMenu from './HeaderMobile/AccountMenu';
import MenuMobileIcon from './HeaderMobile/MenuMobileIcon';
import Logo from './Logo';
import StyledContainer from './StyledContainer';
import StyledNav from './StyledNav';

const Header: React.FC = ({ ...rest }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  return (
    <StyledContainer>
      <Row>
        <Col>
          <StyledNav {...rest}>
            <Row
              align={'center'}
              justify={'space-between'}
            >
              <Col
                lg={3}
                xs={3}
              >
                <Logo />
              </Col>
              <Col
                lg={9}
                xs={1}
              >
                <Visible desktop>
                  <MenuDesktop />
                </Visible>

                <Visible mobile>
                  <MenuMobileIcon
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    isMenuOpen={isMenuOpen}
                  />
                </Visible>
              </Col>
            </Row>
          </StyledNav>
        </Col>
      </Row>
      <Visible mobile>
        <Row noGutters>
          {isMenuOpen && (
            <Col xs={4}>
              <AccountMenu />
            </Col>
          )}
        </Row>
      </Visible>
    </StyledContainer>
  );
};

export default memo(Header);
